import { Provider } from '@angular/core';
import {
  NUCLEUS_MAIL_REPORT_FILENAME,
  NUCLEUS_MAIL_SERVICE,
} from '@nucleus/mail-report-ui';

import { TasksenseMailServiceAdapter } from './tasksense-mail.adapter';

export * from './tasksense-mail.adapter';

// NUC-294: the mail-report lib gates on MailCaps codes via the shared
// CAPABILITY_CHECKER (wired app-wide to PermissionsService); the old
// NUCLEUS_MAIL_PERMISSIONS seam was removed in @nucleus/mail-report-ui 0.0.29.
export const NUCLEUS_MAIL_UI_PROVIDERS: Provider[] = [
  { provide: NUCLEUS_MAIL_SERVICE,         useExisting: TasksenseMailServiceAdapter },
  { provide: NUCLEUS_MAIL_REPORT_FILENAME, useValue: 'tasksense-mail-report' },
];
